export enum AppointmentTypes {
  MEET_GREET="meet_greet",
  ONBOARD_PARENT="onboard_parent",
  ONBOARD_PATIENT="onboard_patient",
  FOLLOW_UP_PARENT="follow_up_parent",
  FOLLOW_UP_PATIENT="follow_up_patient",
  OTHER="other",
}